import { Component } from 'react';
import styled from 'styled-components';

export const JobPage = styled.div`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const MobileTabsMenu = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  position: relative;
  @media (max-width: 400px) {
    justify-content: flex-start;
    flex-direction: column-reverse;
  }
`;

export const MobileActions = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  margin-right: 20px;
  @media (max-width: 400px) {
    margin-right: 0;
    margin-top: 20px;
  }
`;

export const MobileStatisticsMenu = styled.div`
  display: flex;
  justify-content: space-between;
  > div:nth-child(1) {
    flex: 1;
  }
  > div:nth-child(2) {
    margin-left: 20px;
  }
`;

export class BulkActions extends Component {
  render() {
    const { onKeyboardFocus, children, ...rest } = this.props;
    return <BulkA {...rest}>{children}</BulkA>;
  }
}

export const BulkA = styled.div`
  display: flex;
  align-items: center;
  background-color: rgba(49, 47, 76, 0.05);
  border-radius: 2px;
  font-size: 13px;
  padding: 6px 8px 6px 12px;
  text-transform: uppercase;
  width: 100%;
  :hover {
    cursor: pointer;
  }
  color: ${(p) => p.theme.textColor};
`;
